export default "__VITE_ASSET__a88899f6__"